import { format, money, MoneyError, parseAmount } from '@zt/money';
import { useI18n } from './i18n';

const TAG: Record<string, string> = { tr: 'tr-TR', en: 'en-GB', de: 'de-DE', ar: 'ar' };

/** Kuruş → ekranda "1.299,90 ₺". Hesap için kullanılmaz. */
export function useMoney() {
  const { locale } = useI18n();
  return (amountMinor: number | null | undefined, currency: string | null | undefined) =>
    amountMinor === null || amountMinor === undefined || !currency
      ? '—'
      : format(money(amountMinor, currency), TAG[locale] ?? 'tr-TR');
}

/** Kullanıcının yazdığı tutarı ("1.299,90") kayan nokta kullanmadan kuruşa çevirir; okunamazsa null. */
export function toMinor(input: string, currency: string): number | null {
  if (!input.trim()) return null;
  try {
    return parseAmount(input, currency).amountMinor;
  } catch (e) {
    if (e instanceof MoneyError) return null;
    throw e;
  }
}

/** Kuruşu düzenleme alanı için metne çevirir ("129990" → "1299,90"). */
export function minorToInput(amountMinor: number | null | undefined): string {
  if (amountMinor === null || amountMinor === undefined) return '';
  const neg = amountMinor < 0;
  const s = String(Math.abs(amountMinor)).padStart(3, '0');
  return `${neg ? '-' : ''}${s.slice(0, -2)},${s.slice(-2)}`;
}

/** Baz puan → "%20" / "%7,5". */
export function bpsLabel(bps: number): string {
  const whole = Math.trunc(bps / 100);
  const frac = Math.abs(bps % 100);
  return frac ? `%${whole},${String(frac).padStart(2, '0').replace(/0$/, '')}` : `%${whole}`;
}

/** TCMB kur metni ("48.6120") → yerel ondalıkla ("48,6120"); kayan noktaya çevrilmez. */
export function rateLabel(rate: string, locale: string): string {
  return locale === 'en' ? rate : rate.replace('.', ',');
}
